const NAMESPACES = {
  CONVERATION_BUILDER: 'conversationbuilder',
  BOT_PLATFORM: 'botplatform',
  LIVE_INTENT: 'liveintent',
  INTENT_ANNOTATOR: 'intentannotator',
  INTENT_MANAGER: 'intentmanager',
  INTENT_BUILDER: 'intentbuilder',
  PERFORMANCE_OPTIMIZER: 'performaceoptimizer',
  DATA_TRANSPORTER: 'datatransporter',
  CONVERSATION_ASSIST: 'conversationassist',
  AIWB: 'aiworkbench',
  MC: 'mc',
  IHU: 'ihu',
};

export default NAMESPACES;
